module.exports = __webpack_public_path__ + "static/4-76e5e72c514d6ca64ceb13f88599c7d4.png";